<template>
  <div class="dimed wrap" style="z-index:7">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.BasketDel.msg1') }}</div>
        <div class="ft-error">{{ $t('Modal.BasketDel.msg2') }}</div>
        <div class="lyr-txt">{{ $t('Modal.BasketDel.msg3') }}</div>
      </div>
      <div class="layer__body">
        <div class="info-area">
          <span class="img-error yellow"></span>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--cancel btn-anim" @mouseup="$emit('closeBasket')">{{ $t('Modal.BasketDel.msg5') }}</button>
        <button class="btn btn--error btn-anim" @mouseup="$emit('setDel')">{{ $t('Modal.BasketDel.msg4') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'basketDel',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  mounted() {
    this.$showButtonAnimation();
  },
  props: {},
  methods: {},
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped></style>
